<template>
  <div class="customer-link">
    <div class="search-wrap">
      <el-input class="search-val" v-model.trim="linkName" placeholder="请输入联系人名称" clearable></el-input>
      <el-input class="search-val" v-model.trim="linkPhone" placeholder="请输入手机号" maxLength="11" clearable></el-input>
      <el-date-picker
        v-model="date"
        class="date-val"
        type="daterange"
        range-separator="至"
        start-placeholder="创建开始日期"
        end-placeholder="创建结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        clearable
        :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
      <div class="operate-btns">
        <el-button type="primary" @click="onSearch" icon="el-icon-search">查询</el-button>
        <el-button plain @click="reset">重置</el-button>
        <auth-button class="right-btn" code="LXRXZ" type="primary" v-if="editable" @click="showNewLink">新建联系人</auth-button>
      </div>
    </div>
    <auth-button icon="el-icon-delete" v-if="editable" class="bitch-dele-btn" size="mini" code="LXRSC" type="danger" plain @click="deleLinks">删除</auth-button>
    <div class="list-table">
      <new-table ref="linksRef" :data="tableData" :columns="columns" :pages="pages" firstType="selection" @selection-change="selectionChange"></new-table>
    </div>
    <new-link v-if="editable" ref="newLinkRef" :showCust="!this.customer.id" @save="saveLink"></new-link>
  </div>
</template>

<script>
import { CustomerApis } from "@/apis";
import { IsChief, LinkSex } from "@/utils/enum";
import NewTable from "@/components/new-table.vue";
import NewLink from "@/views/components/new-link";

export default {
  name: "link-manage",
  props: {
    editable: { type: Boolean, default: true },
    customer: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  created() {
    this.getLinks();
  },
  data() {
    const columns = [
      { label: "姓名", prop: "linkName" },
      { label: "性别", prop: "sex" },
      { label: "手机号", prop: "linkPhone" },
      { label: "邮箱", prop: "linkEmail" },
      { label: "职务", prop: "linkPost" },
      { label: "是否首要联系人", prop: "chief" },
      { label: "创建时间", prop: "creationTime" },
    ];
    if (!this.customer.id) {
      columns.splice(1, 0, {
        label: "客户名称",
        render: (h, { row }) => (
          <span class="text-btn" onClick={() => this.toCustDetail(row)}>
            {row.customerName}
          </span>
        ),
      });
    }
    if (this.editable && this.$store.getters.isAuth("LXRBJ")) {
      columns.push({
        label: "操作",
        width: "80",
        render: (h, { row }) => (
          <auth-button type="text" code="LXRBJ" size="mini" onClick={() => this.editNewLink(row)}>
            编辑
          </auth-button>
        ),
      });
    }
    return {
      linkName: "",
      linkPhone: "",
      date: [],
      tableData: [],
      selectedList: [],
      columns,
      pages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.currentChange(p);
          },
          "size-change": this.sizeChange,
        },
      },
    };
  },
  methods: {
    selectionChange(list) {
      this.selectedList = list;
    },
    getLinks() {
      const params = {
        customerId: this.customer.id,
        linkName: this.linkName,
        linkPhone: this.linkPhone,
        createDate: this.date && this.date[0],
        createEndDate: this.date && this.date[1],
        pageIndex: this.pages.props.currentPage,
        pageSize: this.pages.props.pageSize,
      };
      CustomerApis.getCustLinks(params).then((res) => {
        res.data.forEach((i) => {
          i.sex = LinkSex[i.linkSex];
          i.chief = IsChief[i.isChief];
        });
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    onSearch() {
      this.currentChange(1);
    },
    reset() {
      this.linkName = "";
      this.linkPhone = "";
      this.date = [];
      this.currentChange(1);
    },
    sizeChange(size) {
      this.pages.props.pageSize = size;
      this.currentChange(1);
    },
    currentChange(p) {
      this.pages.props.currentPage = p;
      this.getLinks();
    },
    saveLink() {
      this.getLinks();
      this.$emit("saveLink");
    },
    deleLinks() {
      if (!this.selectedList.length) return this.$message.warning("请先选择联系人");
      let hasChief = this.selectedList.find((i) => i.isChief);
      if (hasChief) return this.$message.warning(`"${hasChief.linkName}" 是首要联系人，不能删除`);
      this.$confirm("确定要删除选中的联系人吗？", "注意", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            listId: this.selectedList.map((i) => i.id),
          };
          CustomerApis.batchDeleCustLink(params).then((res) => {
            this.$message.success("删除成功");
            this.$refs.linksRef.clearSelection();
            this.currentChange(1);
          });
        })
        .catch(() => {});
    },
    toCustDetail(row) {
      this.$router.push(`./customer-detail?id=${row.customerId}`);
    },
    showNewLink() {
      const cust = {
        customerId: this.customer.id,
        customerName: this.customer.customerName,
      };
      this.$refs.newLinkRef.show(cust);
    },
    editNewLink(row) {
      this.$refs.newLinkRef.show(row);
    },
  },
  components: { NewTable, NewLink },
};
</script>

<style scoped lang="scss">
.customer-link {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.search-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .search-val {
    width: 170px;
    margin-right: 10px;
    margin-bottom: 18px;
  }
  .date-val {
    width: 270px;
    margin-right: 24px;
    margin-bottom: 18px;
  }
  .operate-btns {
    flex: 1;
    margin-bottom: 18px;
    min-width: 245px;
  }
  .right-btn {
    float: right;
  }
}

.bitch-dele-btn {
  width: 72px;
  margin-bottom: 15px;
}

::v-deep {
  .text-btn {
    color: #3d9cfc;
    cursor: pointer;
  }
}
</style>
